import { ReactNode } from 'react';
import DuctedProductRow from './ducted-product-row';
import { DuctedSlotRow } from './ducted-slot-rows';

type DuctedSlotProductRowProps = Readonly<{
  row: DuctedSlotRow;
  actions?: ReactNode;
}>;

export default function DuctedSlotProductRow({
  row,
  actions
}: DuctedSlotProductRowProps) {
  return (
    <DuctedProductRow
      caption={row.slotLabel}
      modelText={row.modelText}
      product={row.product}
      actions={actions}
    />
  );
}
